<template>
  <div class='animation-tooltip-wrapper'>
    <div :class='[btnClassName, {"disabled": disabled}]' @click.stop="clicked" @mouseenter='mouseEnter'>
      <custom-tooltip class="action" popper-class="light-tooltip">
        <div slot='buttonContent'>
          <div class='popup-icon'>
              <lottie-animation
                :class='animationClassName'
                :ref="refName"
                :loop='!disabled'
                :animationData="animationFile"
                @loopComplete="loopComplete"
              />
          </div>
        </div>
        <div slot="content">
          <slot name="tooltip">
            {{ tooltipText }}
          </slot>
        </div>
      </custom-tooltip>
    </div>
  </div>
</template>

<script>
import LottieAnimation from 'lottie-web-vue';
import CustomTooltip from '@/components/common/CustomTooltip.vue';

export default {
  name: 'AnimationTooltipWrapper',
  components: { CustomTooltip, LottieAnimation },
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    btnClassName: {
      type: String,
      default: '',
      required: false,
    },
    animationClassName: {
      type: String,
      default: '',
      required: false,
    },
    refName: {
      type: String,
      default: '',
      required: true,
    },
    animationFile: {
      type: Object,
      required: true,
    },
    tooltipText: {
      type: String,
      default: '',
      required: false,
    },
  },
  methods: {
    mouseEnter() {
      if (!this.disabled) {
        this.$refs[this.refName].play();
      }
    },
    loopComplete() {
      this.$refs[this.refName].pause();
    },
    clicked() {
      if (!this.disabled) {
        this.$emit('clicked');
      }
    },
  },
};
</script>
